"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetCurrencyIdsByCountryIds = exports.makeGetCountriesMapNamesByIds = exports.makeGetCountriesMapByIds = exports.makeGetCountriesByIds = exports.makeGetCountryByCode = exports.makeGetCountryById = exports.makeGetAvailableCountries = exports.getCommonAvailableCountries = exports.getAvailableCountriesIds = exports.makeGetCountries = exports.getInternationalCountryIds = exports.getInternationalCountries = exports.getNonInternationalCountries = exports.getCustomFields = exports.getGovernments = exports.getExchangeMarketplaceThreshold = exports.getPrintingFeeValue = exports.getEmailCharLimit = exports.getCommonCountriesMap = exports.getCommonCountries = exports.getIsCommonDataLoaded = void 0;

var _ramda = require("ramda");

var _reselect = require("reselect");

var _commonData = require("./commonData.constants");

var getIsCommonDataLoaded = (0, _ramda.path)(['commonData', 'isLoaded']);
exports.getIsCommonDataLoaded = getIsCommonDataLoaded;
var getCommonCountries = (0, _ramda.path)(['commonData', 'countries']);
exports.getCommonCountries = getCommonCountries;
var getCommonCountriesMap = (0, _ramda.path)(['commonData', 'countriesMap']);
exports.getCommonCountriesMap = getCommonCountriesMap;
var getEmailCharLimit = (0, _ramda.path)(['commonData', 'emailCharsLimit']);
exports.getEmailCharLimit = getEmailCharLimit;
var getPrintingFeeValue = (0, _ramda.path)(['commonData', 'printingFeeValue']);
exports.getPrintingFeeValue = getPrintingFeeValue;
var getExchangeMarketplaceThreshold = (0, _ramda.path)(['commonData', 'exchangeMarketplaceThreshold']);
exports.getExchangeMarketplaceThreshold = getExchangeMarketplaceThreshold;
var getGovernments = (0, _ramda.path)(['commonData', 'governments']);
exports.getGovernments = getGovernments;
var getCustomFields = (0, _ramda.path)(['commonData', 'customFields']);
exports.getCustomFields = getCustomFields;
var getNonInternationalCountries = (0, _reselect.createSelector)(getCommonCountries, function (countries) {
  return countries.filter(function (country) {
    return !country.isInternational;
  });
});
exports.getNonInternationalCountries = getNonInternationalCountries;
var getInternationalCountries = (0, _reselect.createSelector)(getCommonCountries, function (countries) {
  return countries.filter(function (country) {
    return country.isInternational;
  });
});
exports.getInternationalCountries = getInternationalCountries;
var getInternationalCountryIds = (0, _reselect.createSelector)(getInternationalCountries, (0, _ramda.map)((0, _ramda.prop)('id')));
exports.getInternationalCountryIds = getInternationalCountryIds;

var makeGetCountries = function makeGetCountries() {
  var hasInternational = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return hasInternational ? getCommonCountries : getNonInternationalCountries;
};

exports.makeGetCountries = makeGetCountries;
var getAvailableCountriesIds = (0, _ramda.path)(['commonData', 'availableCountriesIds']);
exports.getAvailableCountriesIds = getAvailableCountriesIds;
var getCommonAvailableCountries = (0, _reselect.createSelector)(getCommonCountries, getAvailableCountriesIds, function (countries, availableCountriesIds) {
  return countries.filter(function (country) {
    return availableCountriesIds.includes(country.id);
  });
});
exports.getCommonAvailableCountries = getCommonAvailableCountries;

var makeGetAvailableCountries = function makeGetAvailableCountries() {
  var hasInternational = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (0, _reselect.createSelector)(makeGetCountries(hasInternational), getAvailableCountriesIds, function (countries, availableCountriesIds) {
    return countries.filter(function (country) {
      return availableCountriesIds.includes(country.id);
    });
  });
};

exports.makeGetAvailableCountries = makeGetAvailableCountries;

var makeGetCountryById = function makeGetCountryById(countryId) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _commonData.DEFAULT_COUNTRIES.US;
  return (0, _reselect.createSelector)(getCommonCountriesMap, function (countriesMap) {
    return countriesMap[countryId] || defaultValue;
  });
};

exports.makeGetCountryById = makeGetCountryById;

var makeGetCountryByCode = function makeGetCountryByCode(countryCode) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _commonData.DEFAULT_COUNTRIES.US;
  return (0, _reselect.createSelector)(getCommonCountries, function (countries) {
    return countries.find(function (item) {
      return item.code === countryCode;
    }) || defaultValue;
  });
};

exports.makeGetCountryByCode = makeGetCountryByCode;

var makeGetCountriesByIds = function makeGetCountriesByIds(countryIds) {
  return (0, _reselect.createSelector)(getCommonCountriesMap, function (countriesMap) {
    return countryIds.map(function (countryId) {
      return countriesMap[countryId];
    }).filter(function (country) {
      return Boolean(country);
    });
  });
};

exports.makeGetCountriesByIds = makeGetCountriesByIds;

var makeGetCountriesMapByIds = function makeGetCountriesMapByIds(countryIds) {
  return (0, _reselect.createSelector)(getCommonCountriesMap, function (countriesMap) {
    return (0, _ramda.pick)(countryIds, countriesMap);
  });
};

exports.makeGetCountriesMapByIds = makeGetCountriesMapByIds;

var makeGetCountriesMapNamesByIds = function makeGetCountriesMapNamesByIds(countryIds) {
  return (0, _reselect.createSelector)(makeGetCountriesByIds(countryIds), function (countries) {
    return countries.map((0, _ramda.prop)('name'));
  });
};

exports.makeGetCountriesMapNamesByIds = makeGetCountriesMapNamesByIds;

var makeGetCurrencyIdsByCountryIds = function makeGetCurrencyIdsByCountryIds(countryIds) {
  return (0, _reselect.createSelector)(makeGetCountriesByIds(countryIds), function (countries) {
    return countries.map(function (country) {
      return country.currency.id;
    });
  });
};

exports.makeGetCurrencyIdsByCountryIds = makeGetCurrencyIdsByCountryIds;